/* eslint-disable */
import { Box, InputLabel, OutlinedInput } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './CustomInput.module.css';

export const CommonInput = ({
  id,
  dataTestId,
  required,
  inputLabelAriaLabel,
  inputLabelClassName,
  label,
  autoFocus,
  InputClassName,
  handleChange,
  placeholder,
  fullWidth,
  handleBlur,
  inputProps,
  value,
  multiLine,
  rows,
  dataTestIdForLabel,
  endAdornment,
  disabled,
  error,
  tooltip,
  colonEnable,
  removeTopMar,
  asterisk,
  axLabel,
  axValue,
}) => {
  const colorsetClass = (dis, enb) => {
    if (disabled) {
      return dis;
    } else {
      return enb;
    }
  };
  return (
    <>
      <InputLabel
        htmlFor={id}
        data-testid={dataTestIdForLabel}
        className={`${styles.label_title} ${inputLabelClassName || ''}`}
        style={{ float: 'left' }}
      >
        {label || ''}
      </InputLabel>
      {asterisk && <span className={`asterisk ${styles.asteriskForLabel}`}>*</span>}
      {colonEnable && <span className={styles.colonEnableForLabel}>{':'}</span>}
      <OutlinedInput
        data-testid={dataTestId || null}
        id={id}
        multiline={multiLine}
        rows={rows}
        name={id}
        autoFocus={autoFocus || false}
        className={`${removeTopMar ? 'removeTopMar' : ''} ${styles.outlined_inputs} ${
          error ? styles.outlined_inputs_error : ''
        } ${InputClassName || ''}`}
        onChange={handleChange}
        placeholder={placeholder}
        fullWidth={fullWidth || false}
        onBlur={handleBlur}
        inputProps={inputProps || {}}
        tabIndex="0"
        value={value || ''}
        autoComplete="off"
        endAdornment={endAdornment}
        disabled={!!disabled}
        aria-label={inputLabelAriaLabel || null}
        required={required || false}
      />
      {error ? (
        <Box
          className={colorsetClass(styles.error_dis, styles.error)}
          id="paymentError"
          role="alert"
        >
          {error}
        </Box>
      ) : (
        ''
      )}
    </>
  );
};

CommonInput.propTypes = {
  id: PropTypes.string,
  rows: PropTypes.number,
  required: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  InputClassName: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiLine: PropTypes.bool,
  handleBlur: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputProps: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  error: PropTypes.string,
  dataTestId: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  endAdornment: PropTypes.object,
  tooltip: PropTypes.string,
  colonEnable: PropTypes.bool,
  removeTopMar: PropTypes.bool,
  asterisk: PropTypes.bool,
  axLabel: PropTypes.string,
  axValue: PropTypes.string,
};
